import { withFrameOrigin } from '../../utils/frame-origin';

/**
 * Determines if a redirect URL is for a smart-listing flow.
 * Smart listing flows should use browser back navigation instead of forms-specific redirects.
 */
export function isSmartListingUrl(url?: string): boolean {
  return url?.includes('smart-listing') ?? false;
}

/**
 * Determines if we should use the forms-specific redirect logic.
 * Returns false for smart-listing URLs and when no URL is provided.
 */
export function shouldUseFormsRedirect(sendRedirectUrl?: string): sendRedirectUrl is string {
  return !!sendRedirectUrl && !isSmartListingUrl(sendRedirectUrl);
}

/**
 * The URL for "I'm done". A smart-listing redirect goes to Compliance, a third app, so it never
 * receives the partner origin; every other redirect returns to Forms and carries it (AP-3437).
 */
export function imDoneRedirectHref(sendRedirectUrl: string): string {
  return isSmartListingUrl(sendRedirectUrl) ? sendRedirectUrl : withFrameOrigin(sendRedirectUrl);
}
